import React from 'react';
import { Button, Typography, Checkbox, Card, Space } from 'components';
import { DimensionInputs } from 'components/warehouse';
import { useItemDetails } from './useItemDetails';
import { ProgressStepper } from '../components/ProgressStepper';
import styles from './styles.module.scss';

const { Text, Title } = Typography;

export const ItemDetails: React.FC = () => {
  const {
    isLoading,
    itemInfo,
    itemData,
    dimensions,
    quantityConfirmed,
    isSubmitting,
    handleDimensionChange,
    handleUnitChange,
    handleQuantityConfirm,
    handleNext,
    handleBack,
    handleRaiseClaim,
    completedCount,
    totalCount,
  } = useItemDetails();

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <Text>Loading...</Text>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Progress Stepper */}
      <ProgressStepper
        currentStep={3}
        totalSteps={4}
        completedCount={completedCount}
        totalCount={totalCount}
        onBack={handleBack}
      />

      <div className={styles.content}>
        {/* Title */}
        <Title level={3} className={styles.pageTitle}>
          Item successfully identified
        </Title>

        {/* Item Details Card */}
        <Card className={styles.itemCard}>
          <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Text className={styles.itemSku}>SKU: {itemInfo?.sku}</Text>
            {itemData?.name && <Text className={styles.itemDescription}>{itemData.name}</Text>}
          </Space>
        </Card>

        {/* Confirm Quantity Checkbox */}
        <div className={styles.confirmSection}>
          <Checkbox checked={quantityConfirmed} onChange={handleQuantityConfirm} className={styles.checkbox}>
            <Text className={styles.checkboxLabel}>
              Confirm Quantity – <Text className={styles.quantityText}>{itemData?.quantity || 0} item</Text>
            </Text>
          </Checkbox>
        </div>

        {/* Dimensions Section */}
        <div className={styles.dimensionsSection}>
          <DimensionInputs
            title="DIMENSIONS"
            dimensions={dimensions}
            onDimensionChange={handleDimensionChange}
            onUnitChange={handleUnitChange}
          />
        </div>

        {/* Raise Claim Button */}
        <Button type="link" danger onClick={handleRaiseClaim} className={styles.raiseClaimLink}>
          Raise Claim
        </Button>
      </div>

      {/* Bottom Action */}
      <div className={styles.bottomActions}>
        <Button
          type="primary"
          size="large"
          onClick={handleNext}
          disabled={!quantityConfirmed || isSubmitting}
          loading={isSubmitting}
          block
        >
          Next
        </Button>
      </div>
    </div>
  );
};
